import { AccountType } from '@logz-pkg/enums';
import { searchableAccountsApiServiceForExplore } from '@logz-pkg/frontend-services';
import { SearchableAccountV2Model } from '@logz-pkg/models';
import { Observable } from '@logz-pkg/observable';

class SearchableAccountsService {
  state = new Observable<SearchableAccountV2Model[]>([]);
  stateAsMap = new Observable<Record<number, SearchableAccountV2Model>>({});
  isLoading = new Observable<boolean>(false);
  fetchAccounts = async () => {
    this.isLoading.set(true);

    const newAccounts = await searchableAccountsApiServiceForExplore.getAccountsByType([
      AccountType.Owner,
      AccountType.Sub,
      AccountType.Timeless,
      AccountType.Tracing,
      AccountType.Restore,
    ]);

    this.state.set(newAccounts);
    this.stateAsMap.set(Object.fromEntries(newAccounts.map(account => [account.accountId, account])));
    this.isLoading.set(false);

    return newAccounts;
  };

  clear = () => this.state.set([]);
}

export const searchableAccountsServiceForExplore = new SearchableAccountsService();
